<template>
  <div class="addrs-root" :id="id">
    <inputField
      :id="id + 'county'"
      class="addrs-county"
      :value="value.county"
      label="縣/市"
      :disabled="true"
      v-if="isRecord"
    />
    <dropdownBtn
      :id="id + 'county'"
      class="addrs-county"
      v-model="value.county"
      placeholder="請選擇"
      label="縣/市"
      :disabled="disabled"
      :options="options_county"
      @input="onSelectCounty($event)"
      :errorText="errorText.county"
      v-else
    />

    <inputField
      :id="id + 'town'"
      class="addrs-town"
      :value="value.town"
      label="鄉/鎮/區"
      :disabled="true"
      v-if="isRecord"
    />
    <dropdownBtn
      :id="id + 'town'"
      class="addrs-town"
      v-model="value.town"
      placeholder="請選擇"
      label="鄉/鎮/區"
      :disabled="checkTownDisable(disabled)"
      :options="townInfo"
      @input="onSelectTown($event)"
      :errorText="errorText.town"
      v-else
    />

    <inputField
      class="addrs-detail"
      :id="id + 'detail'"
      label="地址"
      placeholder="請輸入"
      inputType="address"
      maxLength="50"
      :disabled="disabled"
      :value="value.detail"
      @onInput="onInputDetail($event)"
      :errorText="errorText.detail"
    />
  </div>
</template>

<script>
import store from 'Store/store';
import dropdownBtn from 'Components/dropdown/dropdown.vue';
import inputField from 'Components/inputField/inputField.vue';

export default {
  name: 'addrsField',
  components: { dropdownBtn, inputField },
  props: {
    id: {
      type: String,
    },
    value: {
      type: Object,
      default: () => {
        return { county: '', town: '', detail: '' };
      },
    },
    label: {
      type: String,
      default: '',
    },
    errorText: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isRecord: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    uid() {
      return this._uid;
    },
    countyInfo() {
      return store.state.main.referenceData.countyTownInfo.countyList;
    },
    townInfo() {
      var townList = [];

      this.countyInfo.forEach((city) => {
        // if (this.value.county === city.countyCode) {
        if (this.value.county === city.countyName) {
          townList = city.townList.map((town) => {
            return {
              text: town.townname,
              // value: town.towncode,
              value: town.townname,
            };
          });
        }
      });

      return townList;
    },
  },
  created() {
    this.countyInfo.forEach((element) => {
      this.options_county.push({
        text: element.countyName,
        // value: element.countyCode,
        value: element.countyName,
      });
    });
  },
  watch: {},
  methods: {
    onSelectCounty(value) {
      this.addrsInfo.county = value;
      this.onInput();
    },
    onSelectTown(value) {
      this.addrsInfo.town = value;
      this.onInput();
    },
    onInputDetail(value) {
      this.addrsInfo.detail = value[this.id + 'detail'];
      this.onInput();
    },
    onInput() {
      this.$emit('input', this.addrsInfo);
    },
    checkTownDisable(disabled) {
      if (
        disabled ||
        this.value.county == null ||
        this.value.county == undefined ||
        this.value.county == ''
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      addrsInfo: { county: '', town: '', detail: '' },
      options_county: [],
    };
  },
};
</script>

<style scoped>
.addrs-county {
  width: 40%;
  float: left;
}
.addrs-town {
  width: 55%;
  float: right;
  margin-left: 10px;
}

@media (min-width: 768px) {
  .addrs-root {
    display: flex;
    justify-content: space-around;
  }
  .addrs-county {
    width: 25%;
  }
  .addrs-town {
    width: 30%;
    margin-left: 10px;
  }
  .addrs-detail {
    width: 50%;
    margin-left: 10px;
  }
}
</style>
